import { graphql } from '@/gql';
import type { PartnerScheduledRideRecordsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchPartnerScheduledRideRecords = async ({
  pagination,
  partnerId,
  partnerCode,
  phoneNumber,
  scheduledRideId,
  isActive,
  isFinished,
  isCanceled,
  isSingle,
  isRepeated,
}: PartnerScheduledRideRecordsQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      partnerId,
      partnerCode,
      phoneNumber,
      scheduledRideId,
      isActive,
      isFinished,
      isCanceled,
      isSingle,
      isRepeated,
      pagination,
    },
    query: graphql(`
      query PartnerScheduledRideRecords(
        $pagination: PaginationInputType
        $partnerId: Float
        $partnerCode: String
        $phoneNumber: String
        $scheduledRideId: Float
        $isActive: Boolean
        $isFinished: Boolean
        $isCanceled: Boolean
        $isSingle: Boolean
        $isRepeated: Boolean
      ) {
        partnerScheduledRides(
          pagination: $pagination
          partnerId: $partnerId
          partnerCode: $partnerCode
          phoneNumber: $phoneNumber
          scheduledRideId: $scheduledRideId
          isActive: $isActive
          isFinished: $isFinished
          isCanceled: $isCanceled
          isSingle: $isSingle
          isRepeated: $isRepeated
        ) {
          count
          rows {
            id
            completedAt
            canceledAt
            updatedAt
            emailedReminderAt
            calledReminderAt
            callerId
            firstPickup
            lastRideAt
            executedAt
            firstName
            lastName
            riderPhone
            rideName
            rideType
            rideMultiple
            pickupTime
            pickupDate
            skipScheduledRideDates
            timeZone
            endAfterXTimes
            endOn
            day0
            day1
            day2
            day3
            day4
            day5
            day6
            repeatEveryXWeek
            streetAddress1
            city1
            state1
            zip1
            lat1
            long1
            streetAddress2
            city2
            state2
            zip2
            lat2
            long2
            noteToDriver
            cancellationReason
            callAttempts
            callToConfirmSurge
            partnerId
            customerCostOverride
            createdAt
            nextPickupTimeString
            createdAtWebsite
            customRiderName
            destinations
            minutesToAutoRetryRequest
            isGoGoMedical
            isDoNotApplySubsidy
            isDoNotApplyExpiringCredits
            minutesBeforeCustomReminder
            minutesAfterCreationCustomReminder
            overrideBigCar
            overrideSmallCar
            overrideBannedCar
            overrideBadDriver
            gender
            levelOfService
            hasOwnWheelchair
            specialInstructions
            numberOfCompanions
            appointmentType
            appointmentTime
            returnTime
            locationName1
            stairStepsForPU
            locationName2
            stairStepsForDO
            dropOffPhoneNumber
            notesForLP
            callerName
            callerPhoneNumber
            serviceType
            confirmedAt
          }
        }
      }
    `),
  });

  return response.data.partnerScheduledRides;
};
